// In your AboutCompanyPage.js
import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import AboutCompany from '../components/aboutcompany';

const AboutCompanyPage = () => {
  return (
    <>
      <Header />
      <AboutCompany />
      <Footer />
    </>
  );
};

export default AboutCompanyPage;